import { render, staticRenderFns } from "./ContactInformation.vue?vue&type=template&id=0b75f464&"
import script from "./ContactInformation.vue?vue&type=script&lang=ts&"
export * from "./ContactInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports